<template>
  <svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M35 4H16C15.72 4 15.48 3.9 15.28 3.7L12.6 1C12.04 0.38 11.26 0.02 10.44 0H3.58C1.6 0 0 1.6 0 3.58V26.42C0 28.4 1.6 30 3.58 30H34.42C36.4 30 38 28.4 38 26.42V7C38 5.34 36.66 4 35 4Z" fill="#85D6F2"/>
</svg>

</template>

<script>
export default {
    name:"FolderComplete"
}
</script>